import type { IConfigurableColumn } from '@shared/table/types';

import {
  createConfigurableColumns,
  defineColumn,
} from '@shared/table/utils/createConfigurableColumns';

// TODO: Change to proper permissions for contribution report
export const CONTRIBUTION_BETS_REPORT_EXPORT_PERMISSION =
  'ext_bonus_system_player_bonuses_report';

export const CONTRIBUTION_BETS_DEFAULT_SORT_FIELD = 'created_at';

export const defaultContributionBetsColumns: IConfigurableColumn[] =
  createConfigurableColumns([
    defineColumn({
      value: 'betId',
      sortingId: null,
      labelKey: 'report.contribution.grid.column.betId',
    }),
    defineColumn({
      value: 'createdAt',
      sortingId: 'created_at',
      labelKey: 'report.contribution.grid.column.createdAt',
    }),
    defineColumn({
      value: 'gameSubProvider',
      sortingId: 'game_sub_provider',
      labelKey: 'report.contribution.grid.column.gameSubProvider',
    }),
    defineColumn({
      value: 'gameType',
      sortingId: 'game_type',
      labelKey: 'report.contribution.grid.column.gameType',
    }),
    defineColumn({
      value: 'gameName',
      sortingId: 'game_name',
      labelKey: 'report.contribution.grid.column.gameName',
    }),
    defineColumn({
      sortingId: null,
      value: 'playerStake',
      labelKey: 'report.contribution.grid.column.playerStake',
    }),
    defineColumn({
      sortingId: null,
      value: 'playerStakeDistribution',
      labelKey: 'report.contribution.grid.column.playerStakeDistribution',
    }),
    defineColumn({
      sortingId: null,
      value: 'contributionPercentage',
      labelKey: 'report.contribution.grid.column.contributionPercentage',
    }),
    defineColumn({
      sortingId: null,
      value: 'maxContributionAmount',
      labelKey: 'report.contribution.grid.column.maxContributionAmount',
    }),
    defineColumn({
      sortingId: null,
      value: 'stakeAmountContribution',
      labelKey: 'report.contribution.grid.column.stakeAmountContribution',
    }),
    defineColumn({
      sortingId: null,
      value: 'contributionBetsStatus',
      labelKey: 'report.contribution.grid.column.contributionBetStatus',
    }),
  ]);
